import { useState, useEffect } from 'react'
import { graphql } from 'gatsby'
import { normalizedData } from '@utils'
import Layout from '@layout'
import Header from '@layout/header/layout-01'
import Footer from '@layout/footer/layout-01'
import PageHeader from '@containers/page-header/layout-04'
import AnmeldungArea from '@containers/anmeldung/layout-01'

const AnmeldungPage = ({ location, data }) => {
  const [fetched, setFetched] = useState(false)
  const [eventRegistrationsFull, setEventRegistrationsFull] = useState(true)
  const [contentSection, setContentSection] = useState('')

  const content = normalizedData(data?.strapiPage?.content || [])

  useEffect(() => {
    const fetchData = async () => {
      const urlParams = new URLSearchParams(location.search)
      const event = urlParams.get('event')
      try {
        const response = await fetch('/api/anmeldung', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-event': event
          }
        })
        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`)
        }
        const data = await response.json()
        if (!content[data.sql_return.content_section]) {
          throw new Error(
            `Content section "${data.sql_return.content_section}" not found`
          )
        }
        setEventRegistrationsFull(data.sql_return.isFull)
        setContentSection(data.sql_return.content_section)
      } catch (err) {
        console.error('Error fetching data:', err)
      } finally {
        setFetched(true)
      }
    }
    fetchData()
  }, [location.search])

  const modifiedHeaderSection = {
    ...content['header-section'],
    ...(fetched
      ? {
          headings:
            content[contentSection !== '' ? contentSection : 'header-section']
              .headings,
          images:
            contentSection !== '' && content[contentSection].images.length > 0
              ? content[contentSection].images
              : content['header-section'].images
        }
      : {
          headings: [],
          images: []
        })
  }

  return (
    <Layout location={location}>
      <Header />
      <main className="site-wrapper-reveal">
        <PageHeader
          data={{
            ...modifiedHeaderSection
          }}
        />
        {contentSection && (
          <AnmeldungArea
            data={{ ...content[contentSection] }}
            dataErrorMessages={{ ...content['error-section'] }}
            registrationsFull={eventRegistrationsFull}
          />
        )}
        {fetched && !contentSection && (
          <AnmeldungArea
            data={{ ...content['error-section'] }}
            registrationsFull={false}
          />
        )}
      </main>
      <Footer />
    </Layout>
  )
}

export { Head } from '@components/head'

export const query = graphql`
  query AnmeldungPageQuery($title: String, $locale: String) {
    strapiPage(
      title: { eq: $title }
      pageType: { eq: "innerpage" }
      locale: { eq: $locale }
    ) {
      content {
        ...StrapiPageContent
      }
      seo {
        ...StrapiPageSEO
      }
    }
  }
`

export default AnmeldungPage
